// extracted by mini-css-extract-plugin
export default {"melodyVideo":"RO-z","isFullWidth":"SO-z","landingPageVideo":"TO-z","play":"UO-z","iframeVideo":"VO-z","playHidden":"WO-z","fullwidth":"XO-z"};